<template>
  <div class="index_content">
    <div class="f-row">
      <Breadcrumb separator=">" class="breadcrumb_zdy">
          当前位置:
          <BreadcrumbItem :to="{name: 'HospitalList'}">医院</BreadcrumbItem>
          <!-- <BreadcrumbItem><a href="javascript:history.back(-1)" >详情页</a></BreadcrumbItem> -->
          <BreadcrumbItem>{{detail.short_name}}</BreadcrumbItem>
      </Breadcrumb>
      <!-- <div>
        <a href="javascript:history.back(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a>
      </div> -->
    </div>
    <div class="layContent">
        <div class="layout layout-header">
            <div class="layout">
                <div class="logo_div_div">
                    <div class="logo_div">
                        <img :src="detail.logo_path | logo_show" />
                    </div>
                </div>
                <div class="layout-normal">
                    <span class="title">{{detail.short_name}}</span>
                    <span class="span_tag" v-if="detail.hospital_level1 && detail.hospital_level2">
                      {{detail.hospital_level1 | hosLevel(detail.hospital_level2)}}
                    </span>
                    <span class="span_tag" v-if="detail.cz_type">{{detail.cz_type | deal('hos_cz_type')}}</span>
                    <span class="span_tag" v-if="detail.type_id">{{detail.type_id | deal('hospital_type')}}</span>
                </div>
            </div>
        </div>
        <div ref="content"></div>
        <Layout class="detail_content" :style="{'min-height':height+'px'}">
            <Sider :class="{'fixed': sider_fixed}" :style="{'height': sider_height+'px'}" ref="sider" hide-trigger width="152">
                <Menu :active-name="active_name" @on-select="change" width="100%">
                    <MenuItem name="base" onclick="_czc.push(['_trackEvent', '医院详情', '医院详情tab点击（医院信息）'])">
                      <i class="iconfont">&#xe634;</i><span>医院信息</span>
                    </MenuItem>
                    <MenuItem :disabled="components_data.indexOf('TeamInfo') == -1" name="team" onclick="_czc.push(['_trackEvent', '医院详情', '医院详情tab点击（团队概况）'])">
                      <i class="iconfont">&#xe64f;</i><span>团队概况</span>
                    </MenuItem>
                    <MenuItem :disabled="components_data.indexOf('NewsInfo') == -1" name="news" onclick="_czc.push(['_trackEvent', '医院详情', '医院详情tab点击（新闻报道）'])">
                      <i class="iconfont">&#xe651;</i><span>新闻报道</span>
                    </MenuItem>
                    <MenuItem :disabled="components_data.indexOf('Win') == -1" name="win" onclick="_czc.push(['_trackEvent', '公司详情', '中标项目'])">
                      <i class="iconfont">&#xe736;</i><span>中标项目</span>
                    </MenuItem>
                    <MenuItem :disabled="components_data.indexOf('Buy') == -1" name="buy" onclick="_czc.push(['_trackEvent', '公司详情', '采购项目'])">
                      <i class="iconfont">&#xe74b;</i><span>采购项目</span>
                    </MenuItem>
                </Menu>
            </Sider>
            <Content :class="{'fixed': sider_fixed}">
                <BaseInfo
                    @handleGetDetail="handleGetDetail"
                    v-show="active_name == 'base'"
                    key="base"></BaseInfo>
                <TeamInfo @callbackData="callbackData" v-show="active_name == 'team'" key="team"></TeamInfo>
                <NewsInfo @callbackData="callbackData" v-show="active_name == 'news'" key="news"></NewsInfo>
                <Win @callbackData="callbackData" v-show="active_name == 'win'" key="win"></Win>
                <Buy @callbackData="callbackData" v-show="active_name == 'buy'" key="buy"></Buy>
            </Content>
        </Layout>
        <div class="content_footer" ref="content_footer"></div>
    </div>
  </div>
</template>

<script>
import BaseInfo from './components/BaseInfo'
import TeamInfo from './components/TeamInfo'
import NewsInfo from './components/NewsInfo'
import Win from './components/Win'
import Buy from './components/Buy'
import filter from 'js/filter'

export default {
  inject: ['login'],
  data() {
    return {
      active_name: 'base',
      detail: '',
      height: 0,
      hos_tag: [],
      sider_fixed: false,
      sider_height: 528,
      components_data: []
    }
  },
  components: {
    BaseInfo,
    TeamInfo,
    NewsInfo,
    Win,
    Buy
  },
  methods: {
    change(name) {
      this.active_name = name
    },
    handleGetDetail(detail) {
      this.$set(this.$data, 'detail', detail)
    },
    callbackData(value) {
      this.components_data.push(value)
    }
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 276
    if('active_name' in this.$route.query) {
      this.active_name = this.$route.query.active_name
    }
    this.$nextTick(() => {
      this.sider_height = this.$refs['sider'].$el.scrollHeight
      console.log(this.sider_height)
      window.onscroll = () => {
        if(this.$refs['content'].getBoundingClientRect().top < (64 - 16)) {
          this.sider_fixed = true
        } else {
          this.sider_fixed = false
        }
        if(this.$refs['content_footer'].getBoundingClientRect().top < (this.sider_height + 64)) {
          this.sider_height = this.$refs['content_footer'].getBoundingClientRect().top - 64
        } else {
          this.sider_height = this.$refs['sider'].$el.scrollHeight
        }
      }
    })
  },
  destroyed() {
    window.onscroll = ""
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
$ul_width = 156px
.index_content
  padding: 16px 0 0
.affix
  .ivu-affix
    z-index: 1000
.layContent
  background: transparent
  margin-top: 36px
.layout
  display: flex
  &-normal
    display: flex
    align-items: center
.layout-header
  padding: 0 32px
  justify-content: space-between
  commonBgColor(#1f2330, #FFFFFF)
  .logo_div_div
    position: relative
    margin-bottom: 12px
    margin-right: 0
    height: 100px
    width: 100px
    min-width: 100px
  .logo_div
    width: 100px
    height: 100px
    border: 1px solid
    line-height: 98px
    background: #fff
    commonBorderColor(#FFFFFF, #E8E8E8)
    position: absolute
    left: 0
    top: -20px
    font-size: 0
    text-align: center
    img
      max-width: 100%
      max-height: 100%
      vertical-align: middle
  .layout-normal
    margin-left: 28px
    .title
      font-size: 24px
      commonColor(#E9E9EB, #333333)
      font-weight: 600
      padding-right: 10px
    .span_tag
      border: 0
      margin-left: 10px
.detail_content
    margin-top: 16px
    // margin-bottom: 30px
    commonBgColor(#1f2330, #FFFFFF)
    .ivu-layout-sider
      overflow: auto
      &.fixed
        position: fixed
        top: 64px
        left: calc((100% - 1200px) / 2)
    & >>> .ivu-menu-light
      background: transparent
      .ivu-menu-item
        font-size 14px
        color #FA5A00
        cursor pointer
        &:hover
          background: #fffaf5
        &.ivu-menu-item-disabled
          color #999 !important
          background: #fff
      &:after
        content: none
      .ivu-menu-item-active:not(.ivu-menu-submenu)
        commonBgColor(rgba(255,255,255,0.05), #fffaf5)
        color: rgba(250, 122, 80, 1)
        span
          font-weight: 800
        &:after
          content: none
    .ivu-layout-content
      border-left: 1px solid
      commonBorderColor(#40444F, #E9E9E9)
      overflow: auto
      position: relative
      &.fixed
        margin-left: 152px
      &::-webkit-scrollbar-track
        border: 0;
        commonBgColor(#1F2330, #FFFFFF)
      &::-webkit-scrollbar
        width: 4px;
        commonBgColor(#1F2330, #FFFFFF)
      &::-webkit-scrollbar-thumb
        border-radius: 4px;
        commonBgColor(#4c4f59, #e8e8e8)
.content_footer
  height: 30px
  commonBgColor(#181a23, #f5f7f9)
  position: relative
  z-index: 100
  width: 100%
</style>
